'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./dropdown.scss');

var _icon = require('../icon/icon');

var _icon2 = _interopRequireDefault(_icon);

var _input = require('../input/input');

var _input2 = _interopRequireDefault(_input);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _keys = require('../../utils/keys');

var _keys2 = _interopRequireDefault(_keys);

var _validation = require('../with-form-field/validation');

var _validation2 = _interopRequireDefault(_validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OPTION_SIZE = {
  small: '40px',
  medium: '40px',
  large: '40px',
  'x-large': '40px'
};

var GROUP_SIZE = {
  small: '30px',
  medium: '30px',
  large: '30px',
  'x-large': '30px'
};

var PLACEHOLDER_SIZE = {
  small: '28px',
  medium: '38px',
  large: '38px',
  'x-large': '58px'
};

var Dropdown = function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  function Dropdown(props) {
    _classCallCheck(this, Dropdown);

    var _this = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

    _this.dropdown = null;
    _this.optionsWrapper = null;
    _this.state = {
      isOpen: false,
      searchInputValue: '',
      placeholder: props.placeholder,
      selectedOption: null,
      preselectedOptionIndex: 0
    };

    _this.openMenu = _this.openMenu.bind(_this);
    _this.closeMenu = _this.closeMenu.bind(_this);
    _this.toggleMenu = _this.toggleMenu.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    _this.handleScrollToOption = _this.handleScrollToOption.bind(_this);
    _this.onInputChange = _this.onInputChange.bind(_this);
    return _this;
  }

  _createClass(Dropdown, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setSelectedValue(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (this.state.selectedOption !== props.selectedValue) {
        this.setSelectedValue(props);
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (!this.state.isOpen && nextState.isOpen) {
        document.addEventListener('click', this.handleBlur, false);
        document.addEventListener('touchstart', this.handleBlur, false);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.isOpen && !this.state.isOpen) {
        document.removeEventListener('click', this.handleBlur, false);
        document.removeEventListener('touchstart', this.handleBlur, false);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleBlur, false);
      document.removeEventListener('touchstart', this.handleBlur, false);
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(event) {
      this.setState({
        searchInputValue: event.target.value,
        preselectedOptionIndex: 0
      });
    }
  }, {
    key: 'getPlaceholder',
    value: function getPlaceholder() {
      var _props = this.props,
          template = _props.template,
          optionLabel = _props.optionLabel;
      var _state = this.state,
          placeholder = _state.placeholder,
          selectedOption = _state.selectedOption;


      if (selectedOption) {
        if (template) {
          return template(selectedOption, { isPlaceHolder: true });
        }

        return selectedOption[optionLabel];
      }

      return placeholder || '';
    }
  }, {
    key: 'setSelectedValue',
    value: function setSelectedValue(_ref) {
      var selectedValue = _ref.selectedValue,
          options = _ref.options,
          optionValue = _ref.optionValue;
      var placeholder = this.props.placeholder;


      if (selectedValue === undefined) {
        return;
      }

      var selectedItemIdex = options.findIndex(function (option) {
        return option[optionValue] === selectedValue;
      });
      var selectedItem = options[selectedItemIdex];

      if (!selectedItem) {
        // eslint-disable-next-line no-console
        console.warn('Make sure that the selectedValue type is the same as optionValue type');
      }

      this.setState({
        placeholder: placeholder,
        selectedOption: selectedItem,
        preselectedOptionIndex: selectedItemIdex
      });
    }
  }, {
    key: 'getOptionsForRender',
    value: function getOptionsForRender() {
      var _props2 = this.props,
          options = _props2.options,
          optionLabel = _props2.optionLabel,
          groupBy = _props2.groupBy,
          searchable = _props2.searchable;
      var searchInputValue = this.state.searchInputValue;

      var modifiedOptions = options;

      if (groupBy) {
        modifiedOptions = modifiedOptions.sort(function (a, b) {
          if (a[groupBy] < b[groupBy]) {
            return -1;
          }

          if (a[groupBy] > b[groupBy]) {
            return 1;
          }

          if (a[optionLabel] < b[optionLabel]) {
            return -1;
          }

          if (a[optionLabel] > b[optionLabel]) {
            return 1;
          }

          return 0;
        });
      }

      if (searchable) {
        modifiedOptions = modifiedOptions.filter(function (option) {
          if (!searchInputValue) {
            return true;
          }

          return option[optionLabel].toLowerCase().indexOf(searchInputValue.toLowerCase()) > -1;
        });
      }

      return modifiedOptions;
    }
  }, {
    key: 'openMenu',
    value: function openMenu(event) {
      event.stopPropagation();

      this.setState({ isOpen: true });
    }
  }, {
    key: 'closeMenu',
    value: function closeMenu(event) {
      if (event) {
        event.stopPropagation();
      }

      this.setState({
        isOpen: false,
        searchInputValue: '',
        preselectedOptionIndex: 0
      });
    }
  }, {
    key: 'toggleMenu',
    value: function toggleMenu(event) {
      event.stopPropagation();

      return this.state.isOpen ? this.closeMenu(event) : this.openMenu(event);
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      event.stopPropagation();

      if (!this.dropdown) {
        return;
      }

      // when we click on an item blur is fired before click and the menu is closed
      // so this prevents the click to be registered
      // so we need to check if the blur is due to click inside the menu
      var isTargetChild = this.dropdown.contains(event.target);
      var isActiveElementChild = this.dropdown.contains(document.activeElement);

      if (isTargetChild || isActiveElementChild) {
        return;
      }

      this.closeMenu();
    }
  }, {
    key: 'handleClick',
    value: function handleClick(option) {
      var _props3 = this.props,
          optionValue = _props3.optionValue,
          optionLabel = _props3.optionLabel,
          onChange = _props3.onChange;


      this.setState({
        selectedOption: option,
        placeholder: option[optionLabel]
      });

      this.closeMenu();

      onChange(option[optionValue]);
    }
  }, {
    key: 'handleScrollToOption',
    value: function handleScrollToOption() {
      var size = this.props.size;
      var preselectedOptionIndex = this.state.preselectedOptionIndex;


      this.optionsWrapper.scrollTop = parseInt(PLACEHOLDER_SIZE[size], 10) * preselectedOptionIndex;
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(event) {
      if (event.key === _keys2.default.UP) {
        event.preventDefault();
        event.stopPropagation();
      }

      if (event.key === _keys2.default.DOWN) {
        event.preventDefault();
        event.stopPropagation();
      }

      // prevent form submitting
      if (event.key === _keys2.default.ENTER) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(event) {
      var options = this.getOptionsForRender();
      var preselectedOptionIndex = this.state.preselectedOptionIndex;

      var _ref2 = this.props || false,
          optionDisabled = _ref2.optionDisabled;

      if (event.key === _keys2.default.UP) {
        this.setState({ preselectedOptionIndex: preselectedOptionIndex - 1 < 0 ? options.length - 1 : preselectedOptionIndex - 1 }, this.handleScrollToOption);
      } else if (event.key === _keys2.default.DOWN) {
        this.setState({
          preselectedOptionIndex: preselectedOptionIndex + 1 >= options.length ? 0 : preselectedOptionIndex + 1,
          isOpen: true
        }, this.handleScrollToOption);
      } else if (event.key === _keys2.default.ENTER) {
        if (options.length === 0) {
          return;
        }

        if (options[preselectedOptionIndex][optionDisabled]) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        this.handleClick(options[preselectedOptionIndex]);
      }
    }
  }, {
    key: 'renderArrowIcon',
    value: function renderArrowIcon() {
      var isOpen = this.state.isOpen;


      return _react2.default.createElement(_icon2.default, { name: isOpen ? 'arrow-up' : 'arrow-down', className: 'dropdown__icon', onClick: this.toggleMenu });
    }
  }, {
    key: 'renderStaticPlaceholder',
    value: function renderStaticPlaceholder() {
      var size = this.props.size;

      var classes = (0, _classnames2.default)('dropdown__placeholder', !this.state.selectedOption && 'dropdown__placeholder--selected');

      return _react2.default.createElement(
        'div',
        {
          className: classes,
          onClick: this.openMenu,
          style: { lineHeight: PLACEHOLDER_SIZE[size], minHeight: PLACEHOLDER_SIZE[size] }
        },
        this.getPlaceholder(),
        this.renderArrowIcon()
      );
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var _props4 = this.props,
          size = _props4.size,
          state = _props4.state;
      var searchInputValue = this.state.searchInputValue;

      var placeholder = this.getPlaceholder();

      return _react2.default.createElement(_input2.default, {
        placeholder: placeholder,
        size: size,
        state: state,
        suffix: this.renderArrowIcon(),
        value: searchInputValue,
        onClick: this.openMenu,
        onChange: this.onInputChange
      });
    }
  }, {
    key: 'renderItem',
    value: function renderItem(item, index) {
      var _props5 = this.props,
          optionValue = _props5.optionValue,
          _props5$optionLabel = _props5.optionLabel,
          optionLabel = _props5$optionLabel === undefined ? optionValue : _props5$optionLabel,
          optionDisabled = _props5.optionDisabled,
          template = _props5.template,
          size = _props5.size;
      var preselectedOptionIndex = this.state.preselectedOptionIndex;

      var classes = (0, _classnames2.default)('dropdown__option', item[optionDisabled] && 'dropdown__option--disabled', index === preselectedOptionIndex && 'dropdown__option--hovered');

      return _react2.default.createElement(
        'div',
        {
          key: item[optionLabel] + '-' + item[optionValue],
          className: classes,
          style: { lineHeight: OPTION_SIZE[size] },
          onClick: this.handleClick.bind(this, item)
        },
        template && template(item, { isOption: true }) || item[optionLabel]
      );
    }
  }, {
    key: 'renderGroupAndItem',
    value: function renderGroupAndItem(item, index) {
      var _props6 = this.props,
          optionValue = _props6.optionValue,
          _props6$optionLabel = _props6.optionLabel,
          optionLabel = _props6$optionLabel === undefined ? optionValue : _props6$optionLabel,
          groupBy = _props6.groupBy,
          size = _props6.size;


      return _react2.default.createElement(
        _react2.default.Fragment,
        { key: item[optionLabel] + '-' + item[optionValue] + '-fragment' },
        _react2.default.createElement(
          'div',
          {
            key: item[optionLabel] + '-' + item[optionValue] + '-group-header',
            className: 'dropdown__option-group-header',
            style: { lineHeight: GROUP_SIZE[size] }
          },
          item[groupBy]
        ),
        this.renderItem(item, index)
      );
    }
  }, {
    key: 'renderItems',
    value: function renderItems() {
      var _this2 = this;

      var _props7 = this.props,
          groupBy = _props7.groupBy,
          state = _props7.state,
          validationMessage = _props7.validationMessage,
          size = _props7.size,
          translation = _props7.translation;

      var dropdownClientRect = this.dropdown.getBoundingClientRect();
      var heightToBottom = dropdownClientRect.bottom;
      var options = this.getOptionsForRender();
      var parsedSize = parseInt(OPTION_SIZE[size], 10);
      var offsetMargin = parsedSize;
      var minHeight = options.length < 3 ? parsedSize * options.length : parsedSize * 3;

      return _react2.default.createElement(
        'div',
        { className: 'dropdown__content' },
        _react2.default.createElement(
          'div',
          {
            ref: function ref(_ref3) {
              _this2.optionsWrapper = _ref3;
            },
            className: 'dropdown__options-wrapper',
            style: { minHeight: minHeight, maxHeight: 'calc(100vh - ' + (heightToBottom + offsetMargin) + 'px)' }
          },
          _react2.default.createElement(
            'div',
            { className: 'dropdown__options' },
            options.map(function (item, index, array) {
              var previousGroup = array[index - 1] && array[index - 1][groupBy];
              var currentGroup = array[index] && array[index][groupBy];
              var isNewGroup = previousGroup === currentGroup;

              return isNewGroup ? _this2.renderItem(item, index) : _this2.renderGroupAndItem(item, index);
            }),
            options.length === 0 && _react2.default.createElement(_validation2.default, {
              className: 'dropdown__nothing-found',
              validationMessage: translation.nothingFound,
              state: 'hint'
            })
          )
        ),
        state && _react2.default.createElement(_validation2.default, {
          className: 'dropdown__validation',
          validationMessage: validationMessage,
          state: state
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state2 = this.state,
          isOpen = _state2.isOpen,
          selectedOption = _state2.selectedOption;
      var _props8 = this.props,
          className = _props8.className,
          label = _props8.label,
          disabled = _props8.disabled,
          searchable = _props8.searchable,
          size = _props8.size,
          state = _props8.state,
          enableShadow = _props8.enableShadow,
          theme = _props8.theme,
          inline = _props8.inline,
          expand = _props8.expand,
          style = _props8.style;


      var wrapperClasses = (0, _classnames2.default)('dropdown-wrapper', isOpen && 'dropdown-wrapper--opened', inline && 'dropdown-wrapper--inline', expand && 'dropdown-wrapper--expand');

      var classes = (0, _classnames2.default)('dropdown', 'dropdown--' + size, disabled && 'dropdown--disabled', state && 'dropdown--state dropdown--state-' + state, theme && 'dropdown--theme-' + theme, enableShadow && !isOpen && 'dropdown--box-shadow', selectedOption && 'dropdown--has-selection', className);

      return _react2.default.createElement(
        'div',
        {
          ref: function ref(dropdown) {
            _this3.dropdown = dropdown;
          },
          className: wrapperClasses,
          'data-e2e': this.props['data-e2e'] || 'dropdown',
          onKeyDown: this.handleKeyDown,
          onKeyUp: this.handleKeyUp,
          style: style
        },
        label && _react2.default.createElement(
          'span',
          { className: 'dropdown__label' },
          label
        ),
        _react2.default.createElement(
          'div',
          {
            className: classes,
            tabIndex: '0',
            onFocus: function onFocus(event) {
              return !_this3.state.isOpen && _this3.openMenu(event);
            },
            onBlur: this.handleBlur
          },
          searchable && this.renderInput(),
          !searchable && this.renderStaticPlaceholder(),
          this.state.isOpen && this.renderItems()
        )
      );
    }
  }]);

  return Dropdown;
}(_react2.default.Component);

Dropdown.propTypes = {
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large', 'x-large']),
  state: _propTypes2.default.oneOf(['success', 'error', 'warning', 'hint']),
  options: _propTypes2.default.array,
  optionValue: _propTypes2.default.string,
  optionLabel: _propTypes2.default.string,
  optionDisabled: _propTypes2.default.string,
  selectedValue: _propTypes2.default.any, // eslint-disable-line
  // TODO  deprecate selectedValue
  value: _propTypes2.default.any, // eslint-disable-line
  groupBy: _propTypes2.default.string,
  searchable: _propTypes2.default.bool,
  template: _propTypes2.default.func,
  validationMessage: _propTypes2.default.string,
  enableShadow: _propTypes2.default.bool,
  translation: _propTypes2.default.object,
  inline: _propTypes2.default.bool,
  theme: _propTypes2.default.oneOf(['dark']),
  'data-e2e': _propTypes2.default.string,
  expand: _propTypes2.default.bool,
  style: _propTypes2.default.object
};

Dropdown.defaultProps = {
  options: [],
  enableShadow: false,
  size: 'medium',
  onChange: function onChange() {
    return false;
  },
  translation: {
    nothingFound: 'Nothing was found'
  },
  inline: false,
  expand: false,
  style: {}
};

exports.default = Dropdown;